"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadyToApplyImageContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactLazyload = _interopRequireDefault(require("react-lazyload"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ReadyToApplyImageContainer = exports.ReadyToApplyImageContainer = function ReadyToApplyImageContainer(_ref) {
  var images = _ref.images,
    qeId = _ref.qeId;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "rta-image-container",
    "data-qe-id": qeId
  }, images.map(function (_ref2, index) {
    var src = _ref2.src,
      alt = _ref2.alt;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "rta-image-wrapper",
      key: src
    }, /*#__PURE__*/_react["default"].createElement(_reactLazyload["default"], {
      offset: 500
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: "rta-card-image",
      src: src,
      alt: alt,
      "data-qe-id": qeId ? "".concat(qeId, "-image").concat(index + 1) : undefined
    })));
  }));
};
ReadyToApplyImageContainer.propTypes = {
  images: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    src: _propTypes["default"].string.isRequired,
    alt: _propTypes["default"].string.isRequired
  })),
  qeId: _propTypes["default"].string
};
ReadyToApplyImageContainer.defaultProps = {
  images: [],
  qeId: undefined
};